/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SeriesType } from '../../models/series-type';

export interface AdminFindById$Params {
  id: number;
}

export function adminFindById(http: HttpClient, rootUrl: string, params: AdminFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<SeriesType>> {
  const rb = new RequestBuilder(rootUrl, adminFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SeriesType>;
    })
  );
}

adminFindById.PATH = '/admin/series-type/{id}';
